import { lazy } from 'react';
/** Открывает карточку питомца */
export const PetDetailsPageAsync = lazy(() => import('./PetDetails/PetDetailsPage'));